module.exports = __webpack_public_path__ + "img/联系商务经理.f4ce55d7.png";